//首先引入axios
import axios from "axios";
// "http://101.43.157.242:8707/"
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // 完整的api地址 = 接口域名+ 接口路径
  timeout: 5000, // 请求超时时间 5s，请求超时
});
//request interceptor   请求拦截器
service.interceptors.request.use(
  (config) => {
    config.headers["token"] = "xxxxxx";
    return config;
  },
  (error) => {
    console.log(error); // for debug
    return Promise.reject(error);
  }
);
// response interceptor  响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.code !== 200) {
      // alert(res.message || "Error");
      // return Promise.reject(new Error(res.message || "Error"));
    } else {
      return res;
    }
  },
  (error) => {
    console.log("err" + error); // for debug
    return Promise.reject(error);
  }
);

export default service;
